module.exports = __webpack_public_path__ + "img/firefly.86463259.png";